import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { cleanStorage } from 'utils/WebService';
import { get } from "./WebService";


export default function AutoLogout({ children }) {

    const logoutTimeout = useRef(null)
    const signoutTime = 1000 * 60 * 60 * 2;
    const [renewTime, setRenewTime] = useState(1000 * 60 * 60)
    const [sessionTimeOut, setSessionTimeOut] = useState(false)

    useEffect(() => {
        var events = [
            'load',
            'mousemove',
            'mousedown',
            'click',
            'scroll',
            'keypress'
        ];

        for (var i in events) {
            window.addEventListener(events[i], resetTimeout);
        }

        resetTimeout();
        setTimeoutToken(renewTime);
    }, [])

    const clearTimeoutFunc = () => {
        if (logoutTimeout.current)
            clearTimeout(logoutTimeout.current);
    };

    const runTimeout = () => {
        logoutTimeout.current = setTimeout(() => {
            logout();
        }, signoutTime);
    };

    const resetTimeout = () => {
        let user = sessionStorage.getItem('user');
        if (user === null || user === undefined)
            logout();

        clearTimeoutFunc();
        runTimeout();
    };

    const setTimeoutToken = (renewTime) => {
        setTimeout(renewToken, renewTime);
    }

    const renewToken = () => {
        get('/users/refresh-token')
            .then(({ token }) => {
                console.log('renew')

                setRenewTime(1000 * 60 * 60)
                sessionStorage.setItem('user', token)
                setTimeoutToken(1000 * 60 * 60);
            })
            // Falha momentânea (backend reiniciando, rede): tenta de novo em 1 minuto, em vez de deslogar na hora e
            // perder o que o usuário estava digitando. Token vencido de fato volta 401 e o WebService já leva ao login.
            .catch(() => {
                if (sessionStorage.getItem('user')) setTimeoutToken(1000 * 60);
                else setSessionTimeOut(true);
            })
    }

    const logout = () => {
        cleanStorage();
        setSessionTimeOut(true);
    };


    return sessionTimeOut ? <Navigate to="/" /> : children;
}

